import {
    Grid
} from '@material-ui/core';
import { CustomButton } from 'components/CustomButton';
import { GenericModal } from 'components/GenericModal';
import { Row } from 'components/Row';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { closeModal, openModal } from 'store/modules/ModalActions';
import ModalConfirm from '../ModalConfirm';
import './index.scss';
import { FormUrl } from './__typex';
import { postConcluirPesquisa, postPerguntarDepois } from 'store/modules/AllContratos/AllContratosActions';
interface ModalProps {
    formUrl: FormUrl;
    modalKey: string;
}

const ModalFiles = ({ formUrl, modalKey }: ModalProps) => {
    const dispatch = useDispatch();
    const languageValues = useSelector(
        (state: RootState) => state.languages.languageValues
    );

    const iFrameProps = [
        {
            title: 'iFrame-title-1',
            url: 'https://forms.office.com/Pages/ResponsePage.aspx?id=TJYjMh9uuki3BUIzUSgajE-Rlhp25_hHrKngbzn4OYdUMDBJUk1MWlZNVElNV0YwWFYzVzJMWDNOUyQlQCN0PWcu'
        },
        {
            title: 'iFrame-title-2',
            url: 'https://forms.office.com/Pages/ResponsePage.aspx?id=TJYjMh9uuki3BUIzUSgajE-Rlhp25_hHrKngbzn4OYdUNUo2NkxHWUFLMkk1NTc5N0kxSERZNzRVWiQlQCN0PWcu'
        }
    ]

    const confirmModalContent = () => {
        return <>
            <p>{languageValues.participacaoEssencial}</p>
            <p>{languageValues.confirmarConclusaoDaPesquisa}</p>
        </>
    }

    const fecharModalSemPerguntarDepois = () => {
        dispatch(closeModal(modalKey));
    };

    const handleConcluirPesquisa = () => {
        dispatch(postConcluirPesquisa(fecharModalSemPerguntarDepois, fecharModalSemPerguntarDepois))
    }

    const handlePerguntarDepois = () => {
        dispatch(postPerguntarDepois(fecharModalSemPerguntarDepois, fecharModalSemPerguntarDepois));
    };

    const handleClose = () => {
        dispatch(closeModal(modalKey));
        handlePerguntarDepois();
    };

    const handleConfirma = () => {
        dispatch(openModal(ModalConfirm, {
            title: languageValues.concluirPesquisa,
            content: confirmModalContent(),
            confirmLabel: languageValues.concluir,
            confirmCallback: () => {
                handleConcluirPesquisa()
            },
            modalKey: 'modalConcluirPesquisa',
            maxWidth: 'sm'
        }))
    }

    return (
        <GenericModal
            id={'contratos-modal-research__id'}
            className='contratos-modal-research'
            onClose={handleClose}
            DialogProps={{
                disableBackdropClick: false,
                disableEscapeKeyDown: false,
                fullWidth: true,
            }}
            title={languageValues.pesquisa}
            footerContent={
                <>
                    <Grid container spacing={1} className='contratos-modal-research__gridContainer-buttons'>
                        <Grid item>
                            <CustomButton
                                id={'contratos-modal-research__cancel'}
                                theme='pufvYellow'
                                className='contratos-modal-research__cancel-button'
                                label={languageValues.perguntarMaisTarde}
                                onClick={handlePerguntarDepois}
                            />
                        </Grid>
                        <Grid item>
                            <CustomButton
                                id={'contratos-modal-research__confirm'}
                                theme='pufvYellow'
                                className='contratos-modal-research__confirm-button'
                                label={languageValues.concluir}
                                onClick={handleConfirma}
                            />
                        </Grid>
                    </Grid>
                </>
            }
        >
            <Row>
                <iframe
                    title={iFrameProps[formUrl].title}
                    src={iFrameProps[formUrl].url}
                    className='contratos-modal-research__iFrame'
                />
            </Row>
        </GenericModal>
    );
};

export default React.memo(ModalFiles)
